/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query'
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { customInstance } from '../../mutator'
import type { HTTPValidationError, ProjectConnectionUsageDTO } from '../fastAPI.schemas'

/**
 * How many anchors use each project Zugverbinder, and how many of them
are set to it by hand.
 * @summary Get Connection Usage
 */
export const getConnectionUsage = (projectGuid: string, signal?: AbortSignal) => {
  return customInstance<ProjectConnectionUsageDTO[]>({
    url: `/projects/${projectGuid}/connection-usage`,
    method: 'GET',
    signal,
  })
}

export const getGetConnectionUsageQueryKey = (projectGuid?: string) => {
  return [`/projects/${projectGuid}/connection-usage`] as const
}

export const getGetConnectionUsageQueryOptions = <
  TData = Awaited<ReturnType<typeof getConnectionUsage>>,
  TError = HTTPValidationError,
>(
  projectGuid: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getConnectionUsage>>, TError, TData>
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetConnectionUsageQueryKey(projectGuid)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getConnectionUsage>>> = ({ signal }) =>
    getConnectionUsage(projectGuid, signal)

  return { queryKey, queryFn, enabled: !!projectGuid, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getConnectionUsage>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type GetConnectionUsageQueryResult = NonNullable<
  Awaited<ReturnType<typeof getConnectionUsage>>
>
export type GetConnectionUsageQueryError = HTTPValidationError

/**
 * @summary Get Connection Usage
 */

export function useGetConnectionUsage<
  TData = Awaited<ReturnType<typeof getConnectionUsage>>,
  TError = HTTPValidationError,
>(
  projectGuid: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getConnectionUsage>>, TError, TData>
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetConnectionUsageQueryOptions(projectGuid, options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

  query.queryKey = queryOptions.queryKey

  return query
}
